import Vue from 'vue';
import Vuex from 'vuex';
import { modules } from '../modules';
import oldGlobalStore from './oldGlobalStore';

Vue.use(Vuex);

const store = {
	modules,
	...oldGlobalStore
};

export default new Vuex.Store(store);
